import { fieldLimits } from "config";
import React, { type ChangeEvent, useCallback } from "react";

import type { CustomProp } from "./entityForms.types";
import LineIcon from "./LineIcon";

import styles from "./CustomAttrRow.module.css";
import formStyles from "./formDialog.module.css";

type CustomAttrRowProps = {
	/** Prefixes input ids so multiple dialogs can coexist, e.g. "person", "place". */
	idPrefix: string;
	keyLabel: string;
	onChange: (id: string, field: "key" | "value", value: string) => void;
	onRemove: (id: string) => void;
	prop: CustomProp;
	removeLabel: string;
	valueLabel: string;
};

const CustomAttrRow = ({
	idPrefix,
	keyLabel,
	onChange,
	onRemove,
	prop,
	removeLabel,
	valueLabel
}: CustomAttrRowProps) => {
	const onKeyChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>): void => onChange(prop.id, "key", event.target.value),
		[onChange, prop.id]
	);
	const onValueChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>): void => onChange(prop.id, "value", event.target.value),
		[onChange, prop.id]
	);
	const onRemoveClick = useCallback((): void => onRemove(prop.id), [onRemove, prop.id]);

	return (
		<div className={styles.customAttrRow}>
			<div className={formStyles.personFormField}>
				<label htmlFor={`${idPrefix}-custom-key-${prop.id}`}>{keyLabel}</label>
				<input
					id={`${idPrefix}-custom-key-${prop.id}`}
					maxLength={fieldLimits.customPropertyKey}
					onChange={onKeyChange}
					type="text"
					value={prop.key}
				/>
			</div>
			<div className={formStyles.personFormField}>
				<label htmlFor={`${idPrefix}-custom-value-${prop.id}`}>{valueLabel}</label>
				<input
					id={`${idPrefix}-custom-value-${prop.id}`}
					maxLength={fieldLimits.customPropertyValue}
					onChange={onValueChange}
					type="text"
					value={prop.value}
				/>
			</div>
			<button aria-label={removeLabel} className={styles.customAttrRemove} onClick={onRemoveClick} type="button">
				<LineIcon name="trash" />
			</button>
		</div>
	);
};

export default CustomAttrRow;
